import { useTranslation } from 'hooks';
import { FC } from 'react';
import Button from 'shared/ui/button/button';
import { Modal } from 'shared/ui/modal/modal';
import { ModalActions } from 'shared/ui/modal/modal-actions/modal-actions';
import cls from './baseCancellationBlockedModal.module.scss';

interface BaseCancellationBlockedModalProps {
  isOpen: boolean;
  heading: string;
  reason: string;
  onClose: () => void;
  onManageLicenses?: () => void;
}

export const BaseCancellationBlockedModal: FC<
  BaseCancellationBlockedModalProps
> = ({ isOpen, heading, reason, onClose, onManageLicenses }) => {
  const { t } = useTranslation();

  return (
    <Modal width={450} isOpen={isOpen} onClose={onClose} className={cls.modal}>
      <h3>{heading}</h3>
      <p>{reason}</p>
      <ModalActions>
        {onManageLicenses && (
          <Button theme='text' tone='default' onClick={onManageLicenses}>
            {t('manageSubscriptions')}
          </Button>
        )}
        <Button theme='filled' tone='default' onClick={onClose}>
          {t('cancel')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
